<template>
  <v-container fluid class="monitorSite px-4">
    <br />
    <h1>Reports</h1>
    <br />

    <div style="width: 100%; height: 70vh; border: 1px solid">
      <ag-grid-vue
        id="myGrid"
        @grid-ready="onGridReady"
        style="width: 100%; height: 100%;"
        class="ag-theme-balham center-box elevation-2"
        :columnDefs="columnDefs"
        :rowData="rowData"
        @rowDoubleClicked="onRowDoubleClicked"
        :gridOptions="gridOptions"
        :colResizeDefault="colResizeDefault"
      ></ag-grid-vue>
    </div>

  </v-container>
</template>

<script>
// @ is an alias to /src
import { adminService } from "@/services/adminService.js";
import router from "@/router";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "Reports",
  data: () => ({
    columnDefs: null,
    rowData: [],
    chartData: [],
    footerRowData: []
  }),
  components: {
    AgGridVue
  },
  methods: {
    onRowDoubleClicked (evt) {
      const selectedRowData = evt.data;
      if (selectedRowData) {
        router.push({
          name: "admin.reportmain",
          params: { reportId: selectedRowData.reportId }
        });
      }
    }
  },
  mounted () {
    let me = this;

    adminService
    .getReports()
    .then(function (resp) {
      var tmpColumnDef = {};
      // console.log('response = ' + JSON.stringify(resp));
      // console.log('response.data = ' + JSON.stringify(resp.data));
      tmpColumnDef.cellClass = "text-left";
      me.columnDefs.push(tmpColumnDef);
      me.rowData = resp.data.records;
      // console.log('rowData = ' + JSON.stringify(me.rowData));
    })
    .catch(function (err) {
      console.error(err);
    });

    this.columnDefs = [
      { headerName: "Report ID",
        field: "reportId",
        width: 100,
        sortable: true
      },
      {
        headerName: "Report Name",
        field: "name",
        width: 700,
        sortable: true
      }
    ];
  }
}

</script>

<style scoped>
.welcome {
  text-align: left;
  font-size: 14pt;
  font-style: italic;
  margin: 0;
  /* color: #0f5182; */
}
.stats-box {
  border: 1px solid dimgray;
  border-radius: 5px;
  /* background-color: #d8e2f5; */
  background-color: #e8eef9;
}
.admin-section {
  border: 1px solid gray;
  background-color: white;
  border-radius: 5px;
}
</style>
